import Express from "@Meridian-Developers/meridian-ui/middleware_controller";
import CustomerHelper from "./CustomerHelper";

class PaymentUIHelper {
    async submitWalletPayment(
        {
            PaymentToken,
            CustomerID,
            AllowCreditCard,
            AllowECheck,
            CartItems,
            PaymentSource,
            PaymentType,
        },
        callback
    ) {
        const ccbAvail = await Express.callAsync("check-ccb");

        if (ccbAvail) {
            const userId = await CustomerHelper.fetchUserId();

            const paymentInput = {
                PaymentToken,
                CustomerID,
                AllowECheck,
                AllowCreditCard,
                CartItems,
                PaymentSource,
                PaymentOrigin: "Portal-Wallet-" + navigator.userAgent,
            };

            Express.call(
                "post-wallet-payment",
                {
                    parameters: paymentInput,
                    userId,
                    cisDivision: PaymentType == "credit" ? "CC" : "ACH",
                },
                (results) => {
                    Express.call(
                        "invalidate-session-item",
                        {
                            sessionId: Express.getSessionId(),
                            key: "history",
                        },
                        (sessResults) => {
                            Express.call(
                                "invalidate-session-item",
                                {
                                    sessionId: Express.getSessionId(),
                                    key: "accountListing",
                                },
                                (sessResults) => {
                                    Express.call("validate-session", {
                                        sessionId: Express.getSessionId(),
                                    });
                                }
                            );
                        }
                    );

                    if (callback) {
                        callback(results);
                    }
                    return results;
                }
            );
        } else {
            const error = { error: "Services unavailable" };
            if (callback) {
                callback(error);
            }
            return error;
        }
    }

    async submitOneTimePayment(
        {
            b2pResponse,
            PaymentToken,
            CustomerID,
            AllowCreditCard,
            AllowECheck,
            CartItems,
            PaymentSource,
            email,
            PaymentType,
        },
        callback
    ) {
        try {
            let origin = "Portal-One-Time ";
            if (PaymentSource) {
                origin = PaymentSource + " ";
            }

            const paymentInput = {
                PaymentToken,
                CustomerID,
                AllowECheck,
                AllowCreditCard,
                CartItems,
                PaymentSource,
                PaymentOrigin: origin + navigator.userAgent,
            };

            let userId = null;

            if (!email) {
                userId = await CustomerHelper.fetchUserId();
            }

            Express.call(
                "post-iframe-payment",
                {
                    b2pResponse,
                    parameters: paymentInput,
                    userId,
                    email,
                    cisDivision: PaymentType == "credit" ? "CC" : "ACH",
                },
                (results) => {
                    if (userId) {
                        Express.call(
                            "invalidate-session-item",
                            {
                                sessionId: Express.getSessionId(),
                                key: "history",
                            },
                            (sessResults) => {
                                Express.call(
                                    "invalidate-session-item",
                                    {
                                        sessionId: Express.getSessionId(),
                                        key: "accountListing",
                                    },
                                    (sessResults) => {
                                        Express.call("validate-session", {
                                            sessionId: Express.getSessionId(),
                                        });
                                    }
                                );
                            }
                        );
                    }

                    if (callback) {
                        callback(results);
                    }
                    return results;
                }
            );
        } catch (e) {
            const error = { error: "Services unavailable" };
            if (callback) {
                callback(error);
            }
            return error;
        }
    }

    async schedulePayment(
        {
            PaymentToken,
            CustomerID,
            AllowCreditCard,
            AllowECheck,
            CartItems,
            PaymentSource,
            paymentDate,
            PaymentType,
        },
        callback
    ) {
        const userId = await CustomerHelper.fetchUserId();

        const paymentInput = {
            PaymentToken,
            CustomerID,
            AllowECheck,
            AllowCreditCard,
            CartItems,
            PaymentSource,
        };

        Express.call(
            "schedule-payment",
            { parameters: paymentInput, userId, paymentDate },
            (results) => {
                if (callback) {
                    callback(results);
                }
                return results;
            }
        );
    }

    async scheduleRecurringPayment(
        {
            PaymentToken,
            CustomerID,
            AllowCreditCard,
            AllowECheck,
            CartItems,
            PaymentSource,
            recurringOptions,
            PaymentType,
        },
        callback
    ) {
        const userId = await CustomerHelper.fetchUserId();

        const paymentInput = {
            PaymentToken,
            CustomerID,
            AllowECheck,
            AllowCreditCard,
            CartItems,
            PaymentSource,
        };

        Express.call(
            "schedule-recurring-payment",
            {
                parameters: paymentInput,
                userId,
                paymentOptions: recurringOptions,
            },
            (results) => {
                if (callback) {
                    callback(results);
                }
                return results;
            }
        );
    }

    async submitPOSPayment(
        {
            b2pResponse,
            PaymentToken,
            CustomerID,
            AllowCreditCard,
            AllowECheck,
            CartItems,
            PaymentSource,
            email,
            cisDivision,
            tenderType,
            saId,
            tenderSource,
            tenderControlId,
            checkNumber,
        },
        callback
    ) {
        try {
            const paymentInput = {
                PaymentToken,
                CustomerID,
                AllowECheck,
                AllowCreditCard,
                CartItems,
                PaymentSource,
            };

            let userId = null;

            if (!email) {
                userId = await CustomerHelper.fetchAgentUserId();
            }

            Express.call(
                "post-pos-payment",
                {
                    b2pResponse,
                    parameters: paymentInput,
                    userId,
                    email,
                    cisDivision: cisDivision || tenderType,
                    tenderType,
                    saId,
                    tenderSource,
                    tenderControlId,
                    checkNumber,
                },
                (results) => {
                    if (userId) {
                        Express.call(
                            "invalidate-session-item",
                            {
                                sessionId: Express.getSessionId(),
                                key: "history",
                            },
                            (sessResults) => {
                                Express.call(
                                    "invalidate-session-item",
                                    {
                                        sessionId: Express.getSessionId(),
                                        key: "accountListing",
                                    },
                                    (sessResults) => {
                                        Express.call("validate-session", {
                                            sessionId: Express.getSessionId(),
                                        });
                                    }
                                );
                            }
                        );
                    }

                    if (callback) {
                        callback(results);
                    }
                    return results;
                }
            );
        } catch (e) {
            const error = { error: "Services unavailable" };
            if (callback) {
                callback(error);
            }
            return error;
        }
    }

    generateCart(accountBalances) {
        // Expecting { 0123456789: 1.00 }
        let results = [];

        const keys = Object.keys(accountBalances);

        for (let i = 0; i < keys.length; i++) {
            const accountId = keys[i];
            const amount = parseFloat(accountBalances[accountId]).toFixed(2);

            if (amount > 0) {
                results.push({
                    ProductName: "Utility",
                    AccountNumber1: accountId,
                    Amount: amount,
                });
            }
        }

        return results;
    }
}
export default new PaymentUIHelper();
